import React, { forwardRef, useImperativeHandle, useState } from 'react'
import { FiChevronDown, FiChevronUp } from 'react-icons/fi'
import Flex from 'typescript-styled-flex'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { markNotificationAsRead } from '../../actions/notification/notifications'
import ArrowButton from './ArrowButton'
import NotificationFooter from './NotificationFooter'

const Expander = forwardRef((props: any, ref) => {
  const [expand, setExpand] = useState(false)
  const dispatch = useDispatch()
  const { t } = useTranslation()

  function toggleExpand() {
    if (!expand) {
      dispatch(markNotificationAsRead(props.id))
    }
    setExpand(!expand)
  }

  useImperativeHandle(ref, () => ({
    expand: () => toggleExpand(),
  }))

  return (
    <Flex column={true}>
      <Flex
        row={true}
        justifyBetween={true}
        style={{
          cursor: 'pointer',
          paddingBottom: props.size ? `${18 * props.size}px` : '18px',
          paddingLeft: props.size ? `${70 * props.size}px` : '70px',
          paddingRight: props.size ? `${18 * props.size}px` : '18px',
        }}
        onClick={toggleExpand}
      >
        <NotificationFooter size={props.size}>
          {props.label && props.label !== '' && props.label !== null
            ? props.label
            : expand
            ? t('less_info_btn')
            : t('more_info_btn')}
        </NotificationFooter>
        <ArrowButton size={props.size}>
          {expand ? (
            <FiChevronUp size={props.size ? `${16 * props.size}px` : '16px'} />
          ) : (
            <FiChevronDown
              size={props.size ? `${16 * props.size}px` : '16px'}
            />
          )}
        </ArrowButton>
      </Flex>
      {expand && props.children}
    </Flex>
  )
})

export default Expander
